<h2 mat-dialog-title>Export to Briefcase</h2>
<mat-dialog-content style="height: 478px; padding: 24px; margin: 0;">
  <!-- Documents -->
  <div style="display: flex; flex-direction: column; gap: 10px">
    <mat-form-field class="show-no-errors">
      <mat-label>Title</mat-label>
      <input matInput [(ngModel)]="briefcase.title">
    </mat-form-field>
    <mat-form-field class="show-no-errors">
      <mat-label>Comments</mat-label>
      <textarea rows="4" matInput [(ngModel)]="briefcase.comments"></textarea>
    </mat-form-field>
    <mat-form-field class="show-no-errors">
      <mat-label>Name Files</mat-label>
      <mat-select matNativeControl [(ngModel)]="briefcase.titleType">
        <mat-option value="0">Using Doc Titles</mat-option>
        <mat-option value="1">Using Bates Numbers</mat-option>
        <mat-option value="2">Using Control Numbers</mat-option>
        <mat-option value="3">Using Master Dates</mat-option>
        <mat-option value="4">Using Original Doc Titles</mat-option>
        <mat-option value="5">Using Doc Ids</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="show-no-errors">
      <mat-label>Control Number Prefix</mat-label>
      <input matInput [(ngModel)]="briefcase.controlNumberBasePrefix">
    </mat-form-field>
    <mat-form-field class="show-no-errors">
      <mat-label>Custom Designation</mat-label>
      <input matInput [(ngModel)]="briefcase.customDesignation">
    </mat-form-field>
    <div class="container">
      <mat-label>Doc Id</mat-label>
      <mat-checkbox matInput [(ngModel)]="briefcase.isDocIdStampPages">Stamp Doc Id on PDF Pages</mat-checkbox>
    </div>
    <div class="container">
      <mat-label>Control Number</mat-label>
      <mat-checkbox matInput [(ngModel)]="briefcase.isControlNumberStampPages">Stamp Existing Control Numbers on PDF Pages</mat-checkbox>
    </div>
    <div class="container">
      <mat-label>Bates Stamp</mat-label>
      <mat-checkbox matInput [(ngModel)]="briefcase.isBatesStampPages">Stamp Existing Bates Numbers on PDF Pages</mat-checkbox>
    </div>
    <div class="container" *ngIf="userConfigService.inRoles(Role.Operations)">
      <mat-label>Exhibit Stamp</mat-label>
      <mat-checkbox matInput [(ngModel)]="briefcase.isExhibitStampPages">Stamp Existing Exhibit Numbers on PDF Pages</mat-checkbox>
    </div>
    <div class="container">
      <mat-label>Notification</mat-label>
      <mat-checkbox matInput [(ngModel)]="briefcase.sendNotification">Send Notification Upon Completion</mat-checkbox>
    </div>
    <div class="container">
      <mat-label>Merge PDFs</mat-label>
      <mat-checkbox matInput [(ngModel)]="briefcase.includeMergedPdfs">Create single PDF for easy printing</mat-checkbox>
    </div>
    <div class="container">
      <mat-label>Allow Sharing</mat-label>
      <mat-checkbox matInput [(ngModel)]="briefcase.allowSharing">Allow others to access this briefcase</mat-checkbox>
    </div>
    <div class="container">
      <mat-label>Expand Email</mat-label>
      <mat-checkbox matInput [(ngModel)]="briefcase.expandToEmailFamily">Expand to Email Family</mat-checkbox>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="primary" (click)="ok()">Create</button>
  <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
